(function () {
  // A looping deck needs a spare card to shuffle: with three or fewer it cannot
  // keep one seated behind the front card AND one on its way out at the same
  // time, so Swiper stops cycling (it bounces between the last two) and the
  // stack loses its backdrop — Swiper's own advice for the case is to add slides
  // or duplicate them. Four is where a set of three starts coming round cleanly.
  const MIN_LOOP_SLIDES = 4;

  // destroy() drops Swiper's own attributes only — a re-init on a slide left
  // inert would stay unfocusable for good.
  function clearSlidesAccessibility(sliderEl) {
    sliderEl.querySelectorAll(".swiper-slide").forEach((slide) => {
      slide.removeAttribute("inert");
      slide.removeAttribute("aria-hidden");
    });
  }

  // Whole sets rather than single cards, so every card comes round the same
  // number of times and the run has no doubled card at the wrap.
  function addLoopCopies(sliderEl) {
    const wrapperEl = sliderEl.querySelector(".swiper-wrapper");
    if (!wrapperEl) return;

    const originals = [...wrapperEl.children];
    if (!originals.length || originals.length >= MIN_LOOP_SLIDES) return;

    const extraSets = Math.ceil(MIN_LOOP_SLIDES / originals.length) - 1;
    for (let set = 0; set < extraSets; set += 1) {
      originals.forEach((slide) => {
        const copy = slide.cloneNode(true);
        copy.dataset.deckCopy = "true";
        // The theme editor maps a block to its settings panel by this attribute,
        // so a copy must not claim to be the block too.
        copy.removeAttribute("data-shopify-editor-block");
        wrapperEl.appendChild(copy);
      });
    }
  }

  function removeLoopCopies(sliderEl) {
    sliderEl
      .querySelectorAll("[data-deck-copy]")
      .forEach((copy) => copy.remove());
  }

  function initSection(section) {
    if (!section || !section.classList.contains("testimonials-section")) return;

    const sliderEl = section.querySelector(".js-testimonials-cards");
    if (!sliderEl) return;

    if (sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
      clearSlidesAccessibility(sliderEl);
    }
    // Always from the merchant's own cards: the setting may have been turned off
    // since the last init, and copies of copies would pile up.
    removeLoopCopies(sliderEl);

    const nextBtn = section.querySelector(".slider-nav-button--next");
    const prevBtn = section.querySelector(".slider-nav-button--prev");

    const hasNavigation = sliderEl.dataset.navigation === "true";
    const sliderLoop = sliderEl.dataset.loop === "true";
    const hasAutoplay = sliderEl.dataset.autoplay === "true";
    const pauseOnHover = sliderEl.dataset.autoplayPauseOnHover === "true";
    const autoplayDelay = Number(sliderEl.dataset.autoplayDelay || 5000);

    if (sliderLoop) addLoopCopies(sliderEl);

    // The deck throws the leaving card out to the inline END of its column —
    // right in LTR, left in RTL — so the drag has to read that same side as
    // "next", the opposite of Swiper's default. A negative touchRatio flips both
    // the live drag and the direction it commits to, and Swiper already negates
    // the drag in RTL, so the single sign follows the throw in both directions.
    // The creative effect's own translate is NOT mirrored by Swiper, hence the
    // explicit sign on it.
    const isRtl = getComputedStyle(sliderEl).direction === "rtl";
    const throwTranslateX = isRtl ? "-115%" : "115%";

    // Cards off the stage keep their product link in the document: without this
    // Tab walks into a card stacked behind the active one, and the deck never
    // moves to it. inert takes the idle cards out of the tab order and off the
    // accessibility tree in one attribute.
    const syncSlidesAccessibility = (swiper) => {
      // By index rather than the active class: this runs on slideChange, before
      // Swiper has necessarily rewritten the classes.
      const activeSlide = swiper.slides[swiper.activeIndex];
      swiper.slides.forEach((slide) => {
        const isActive = slide === activeSlide;
        slide.toggleAttribute("inert", !isActive);
        slide.setAttribute("aria-hidden", isActive ? "false" : "true");
      });
    };

    new Swiper(sliderEl, {
      effect: "creative",
      slidesPerView: 1,
      speed: 400,
      touchRatio: -1,
      // Trackpad two-finger swipe, same as every other slider in the theme.
      // forceToAxis leaves a vertical scroll to the page; invert mirrors the
      // negative touchRatio, so the gesture that throws the card out is the one
      // that advances the deck.
      mousewheel: {
        forceToAxis: true,
        invert: true,
      },
      creativeEffect: {
        // Two states around the active card. Behind it: scaled down and lifted
        // by a share of its own height, so a taller card keeps the proportions
        // (SCSS reserves that peek as the track's top padding). Off to the side:
        // a full-size card clear of the section, which is where a card slides
        // out to and where it slides back in from — 115% covers the card plus
        // the widest container gutter, so it is off-screen at every breakpoint.
        // Depth stays 0 — z-index carries the stack order, and any translateZ
        // makes the card's media box jitter as its own projected plane on drag.
        // The cards stay OPAQUE: the receded look is the CSS wash on the idle
        // slides, so a card at less than full opacity can never let the stack
        // behind it read through the copy of the one in front.
        limitProgress: 1,
        prev: { translate: [throwTranslateX, 0, 0] },
        next: { translate: [0, "-11.15%", 0], scale: 0.89 },
      },
      loop: sliderLoop,
      // The card behind is the whole point of the stack, so the wrap has to
      // arrive with one already seated there. At the default 0 Swiper re-seats
      // the wrapping card only on the next interaction, and the deck reaches
      // the end of the run with nothing behind the front card.
      loopAdditionalSlides: 1,
      a11y: {
        scrollOnFocus: false,
      },
      autoplay: hasAutoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: pauseOnHover,
          }
        : false,
      navigation: hasNavigation
        ? {
            nextEl: nextBtn,
            prevEl: prevBtn,
            disabledClass: "swiper-button-disabled",
          }
        : false,
      on: {
        afterInit: syncSlidesAccessibility,
        slideChange: syncSlidesAccessibility,
        loopFix: syncSlidesAccessibility,
      },
    });
  }

  function destroySection(section) {
    section.querySelectorAll(".js-testimonials-cards").forEach((el) => {
      if (el.swiper) el.swiper.destroy(true, true);
      clearSlidesAccessibility(el);
      removeLoopCopies(el);
    });
  }

  initSection(document.currentScript.parentElement);

  if (!window.__themeTestimonialsCardsEvents) {
    window.__themeTestimonialsCardsEvents = true;

    document.addEventListener("shopify:section:load", function (event) {
      initSection(event.target);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      destroySection(event.target);
    });
  }
})();
